import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useTranslation } from "react-i18next";
import { useState } from "react";

const faqItems = [1, 2, 3, 4, 5, 6, 7, 8, 9];

export default function FAQ() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <div className="bg-deepblack min-h-screen">
      <Navbar />
      <main>
        <section className="relative min-h-[40vh] md:min-h-[45vh] w-full flex items-end pb-16 md:pb-20 overflow-hidden bg-deepblack">
          <div className="absolute inset-0 z-0">
            <img
              src="https://readdy.ai/api/search-image?query=Soft%20warm%20ambient%20light%20illuminating%20a%20luxury%20music%20studio%20with%20elegant%20grand%20piano%20slightly%20out%20of%20focus%20in%20background%20deep%20black%20and%20champagne%20gold%20color%20palette%20minimalist%20cinematic%20composition%20intimate%20atelier%20atmosphere%20high%20contrast%20editorial%20photography%20no%20text%20no%20logos&width=1920&height=600&seq=faq-hero-01&orientation=landscape"
              alt="FAQ"
              className="w-full h-full object-cover object-center opacity-50"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-deepblack/30 via-deepblack/50 to-deepblack" />
          </div>

          <div className="relative z-10 w-full px-6 md:px-12 lg:px-16">
            <span className="inline-block px-4 py-1.5 border border-marble/30 rounded-full text-marble/80 text-xs font-sans tracking-widest uppercase mb-5">
              {t("faq.hero.tag")}
            </span>
            <h1 className="text-marble font-serif text-4xl md:text-5xl lg:text-6xl font-light tracking-wide">
              {t("faq.hero.title")}
            </h1>
            <p className="mt-4 text-marble/50 text-sm md:text-base font-sans max-w-lg leading-relaxed">
              {t("faq.hero.subtitle")}
            </p>
          </div>
        </section>

        <section className="bg-midnight py-20 md:py-28">
          <div className="w-full px-6 md:px-12 lg:px-16 max-w-3xl mx-auto">
            <div className="space-y-4">
              {faqItems.map((i) => {
                const isOpen = openIndex === i;
                return (
                  <div
                    key={i}
                    className="rounded-xl border border-white/5 bg-charcoal/10 overflow-hidden transition-all duration-300"
                  >
                    <button
                      onClick={() => setOpenIndex(isOpen ? null : i)}
                      className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer group"
                    >
                      <h3 className="text-marble font-serif text-base md:text-lg font-light tracking-wide pr-4">
                        {t(`faq.q${i}.question`)}
                      </h3>
                      <span className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 transition-all duration-300 ${
                        isOpen ? "bg-champagne/20 rotate-180" : "bg-white/5"
                      }`}>
                        <i className="ri-arrow-down-s-line text-champagne text-sm" />
                      </span>
                    </button>
                    <div
                      className={`transition-all duration-300 overflow-hidden ${
                        isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
                      }`}
                    >
                      <p className="px-6 pb-6 text-marble/60 text-sm md:text-base font-sans leading-relaxed">
                        {t(`faq.q${i}.answer`)}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="mt-16 text-center pt-12 border-t border-white/5">
              <p className="text-marble/40 text-sm font-sans mb-6">
                {t("faq.bottomText")}
              </p>
              <a
                href="/inquiry"
                className="inline-flex items-center gap-3 bg-champagne hover:bg-champagne/90 text-deepblack px-8 py-3.5 rounded-full text-sm font-sans tracking-widest uppercase transition-all duration-300"
              >
                {t("cta.button")}
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}